import { useScopedAtomValue } from '@lemon8/web-app-shared/ssr';
import { FC } from 'react';
import { VideoEndRecommend } from '~/components/video-end-recommend';
import { $CurrentVideoArticle, $EndRecommendShow, $ReplayVideo } from '@article/body/main/article-video/atoms';
import { useAtomValue } from 'jotai';
import { $CurrentArticleRelatedPost } from '@article/shared/atoms/current-article-related-post';
import { loadable } from 'jotai/utils';

export const VideoEndRecommendSection: FC = () => {
  const article = useScopedAtomValue($CurrentVideoArticle);
  const show = useScopedAtomValue($EndRecommendShow);
  const relatedPost = useAtomValue(loadable($CurrentArticleRelatedPost));
  const { handler } = useScopedAtomValue($ReplayVideo);

  return (
    <VideoEndRecommend
      article={article}
      show={show}
      relatedPost={
        relatedPost.state === 'hasData'
          ? relatedPost.data
          : {
              items: [],
              searchId: '',
              hasMore: true,
              cursor: 0,
            }
      }
      onClickReplay={() => handler()}
    />
  );
};
